 
import React, {useCallback, useState} from 'react';
import UpsellCheckBox from './UpsellCheckBoxes';
import {ProductsContainer} from './styled';
import {Divider, Layout, Button, TextField, Text} from '@phonectas/unifon-ui-kit';
import UpsellMessageBox from './UpsellMessageBox';
import {useTranslation} from 'react-i18next';
import {DialogFooter} from 'common/components/UpsellDialog/styled';
import {VismaUpsellProduct, VismaUpsellResponse} from 'common/types/store/threeSixtyTypes';
import {UpsellOrderModel} from 'common/models/upsellModel';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
import {SECURITY_PRODUCTS_MSG} from '../constants';

interface SecurityProductsProps {
	data: VismaUpsellResponse | null;
	products: VismaUpsellProduct[] | null;
	onSelect: (productId: number) => void;
	removeProduct?: (productId: number) => void;
	temp: number[];
	upsellOrder: UpsellOrderModel;
}

const SecurityProducts: React.FC<SecurityProductsProps> = ({data, products, onSelect, temp, upsellOrder}) => {
	const [t] = useTranslation();
	const {postUpsellOrder} = useThreeSixtyNewStore((state) => ({postUpsellOrder: state.postUpsellOrder}), shallow);
	const [note, setNote] = useState('');

	const handleNoteChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setNote(e.target.value);
		upsellOrder.comment = e.target.value;
	}, [upsellOrder]);

	const canSubmit = useCallback(() => {
		return upsellOrder.cdr_product_ids.length > 0 && upsellOrder.account_id > 0 && upsellOrder.user_id > 0;
	}, [upsellOrder]);

	const handleDontAskAgain = useCallback(() => {
		console.log('User opted not to be asked again');
	}, []);

	const handleSubmit = useCallback(() => {
		const orderData = upsellOrder.getRequestObject();
		const apiOrderData = {
			...orderData,
			comment: orderData.comment || '',
		};
		postUpsellOrder(apiOrderData);
	}, [upsellOrder, postUpsellOrder]);

	return (
		<>
			<Layout style={{padding: '0 16px'}} fullWidth gap="xs">
				<UpsellMessageBox
					/* i18next-extract-disable-next-line */
					message={t(SECURITY_PRODUCTS_MSG)}
					status="ok"
				/>
			</Layout>
			<ProductsContainer>
				{
					products && products.length === 0 ?
						(
							<Text style={{padding: '16px', textAlign: 'center'}}>
								{t('No security products available at the moment.')}
							</Text>
						) : 
						(
							products?.map(opt => (
								<UpsellCheckBox
									key={opt.cdr_product_id}
									{...opt}
									data={opt}
									totalCount={data?.total_subscription_count || 0}
									checked={temp.includes(opt.cdr_product_id)}
									onChange={() => onSelect(opt.cdr_product_id)}
								/>
							))
						)
				}
			</ProductsContainer>
			<Divider />
			<DialogFooter>
				<Layout nowrap style={{padding: '16px'}}>
					<Button
						onClick={handleDontAskAgain}
						variant="secondary"
						color="error"
						disabled={true}
					>
						{t('Don\'t ask again')}
					</Button>
				</Layout>
				<Divider vertical/>
				<Layout nowrap style={{padding: '16px'}} fullWidth>
					<TextField
						placeholder={t('Note (optional)')}
						value={note}
						fullWidth
						onChange={handleNoteChange}
					/>
					<div>
						<Button 
							onClick={handleSubmit}
							variant="primary"
							color="success"
							disabled={!canSubmit()}
						>
							{t('Send to backoffice')}
						</Button>
					</div>
				</Layout>
			</DialogFooter>
		</>
	);
};

export default SecurityProducts;